export default __webpack_public_path__ + "static/media/gold-tea.b658d1c7.jpg";